export default __webpack_public_path__ + "static/media/hiVideo.613eb692.gif";